import React from "react";
import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { fileUrl } from "../lib/api";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import CuratorBadge from "./CuratorBadge";

const stickers = ["bg-cyan", "bg-pink", "bg-yellow", "bg-green"];

export default function ItemCard({ item, idx = 0 }) {
  const img = item.images?.[0];
  const wl = useWishlist();
  const { user } = useAuth();
  const liked = wl?.has(item.id);

  const onHeart = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) { toast.message("Log in to save favorites"); return; }
    const added = await wl.toggle(item.id);
    toast.success(added ? "Saved to your stash" : "Removed");
  };

  return (
    <Link
      to={`/item/${item.id}`}
      className="brut p-3 flex flex-col gap-3 bg-white relative transition-transform hover:-translate-y-1"
      data-testid={`item-card-${item.id}`}
    >
      <div className="aspect-[4/5] overflow-hidden border-4 border-[#1A1A1A] bg-[#f3efe6]">
        {img ? (
          <img src={fileUrl(img)} alt={item.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-display text-4xl text-[#1A1A1A]/30">no pic</div>
        )}
      </div>
      <span className={`tag-sticker absolute -top-3 -right-3 ${stickers[idx % stickers.length]} text-xl rotate-tilt-r`}>${Number(item.price).toFixed(0)}</span>
      {item.featured && (
        <span className="tag-sticker absolute -top-3 -left-3 bg-pink text-lg rotate-tilt-l flex items-center gap-1" data-testid={`pick-${item.id}`}>
          <Star size={14} strokeWidth={3} fill="currentColor" /> Fox's pick
        </span>
      )}
      {item.curator && (
        <div className="absolute top-5 left-5">
          <CuratorBadge curator={item.curator} />
        </div>
      )}
      <button
        onClick={onHeart}
        className={`absolute bottom-5 right-5 brut-sm p-2 ${liked ? "bg-pink text-white" : "bg-white"}`}
        data-testid={`heart-${item.id}`}
        aria-label="Save to wishlist"
      >
        <Heart size={18} strokeWidth={3} fill={liked ? "currentColor" : "none"} />
      </button>
      <div className="flex items-start justify-between gap-2">
        <h3 className="font-display text-xl uppercase leading-tight">{item.title}</h3>
      </div>
      <div className="flex flex-wrap gap-2 text-xs font-bold uppercase tracking-wider">
        <span className="border-2 border-[#1A1A1A] px-2 py-1">{item.size}</span>
        <span className="border-2 border-[#1A1A1A] px-2 py-1">{item.condition}</span>
        {item.brand && <span className="border-2 border-[#1A1A1A] px-2 py-1">{item.brand}</span>}
      </div>
    </Link>
  );
}
